<template>
  <div>
    <search-list ref="searchlist" @searchData="searchData"></search-list>
    <div class="page-wrapper">
      <table-list
        :columns="columns"
        :data="data"
        :current="current"
        :total="total"
        :loading="loading"
        @change-page="changPage"
      ></table-list>

    </div>
    <obsolete :n="obN" :reservationOrderFid="reservationOrderFid" @getData="getData"></obsolete>
    <to-sign-person :n="pN" :projectName="projectName" :projectId="projectId" :reservationId="reservationOrderFid"></to-sign-person>
    <to-sign-bus :n="bN" :projectName="projectName" :projectId="projectId" :reservationId="reservationOrderFid"></to-sign-bus>
  </div>
</template>

<script>
  import SearchList from './components/SearchList'
  import TableList from 'components/TableList/index';
  import Obsolete from './components/Obsolete'
  import ToSignPerson from './components/ToSignPerson'
  import ToSignBus from './components/ToSignBus'
  import {deepClone} from "../../../../utils/format";
  import { canCertificate } from 'api/accountsReceivable'
  import {orderlist,orderclose, getBillNum, invalidDetail } from "../../../../api/book";

  export default {
    name: "booklist",
    components: {
      SearchList,
      TableList,
      Obsolete,
      ToSignPerson,
      ToSignBus
    },
    data() {
      return {
        reservationOrderFid:'',
        projectName:'',
        projectId:'',
        bN:0,
        pN:0,
        obN: 0,
        data: [],
        searchDataValue: {
          "rentEndDate": null,
          "rentStartDate": null,
          "projectFid": '',
          "q": '',
          "rentType": null,
          "reservationDateEnd":null,
          "reservationDateStart":null,
          "reservationSignDateEnd":null,
          "reservationSignDateStart":null,
          "reservationStatus": null,
          "userType": null,
        },
        columns: [
          {
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title: ' '
          },
          {
            title: '项目',
            align: 'center',
            key: 'projectName',
            width: 160,
          },
          {
            title: ' '
          },
          {
            title: '预订单号',
            align: 'center',
            key: 'fcode',
            width: 120,
            render:(h,params)=>{
              return h('a',{
                on:{
                  click:()=>{
                    let query = {
                      fid: params.row['fid'],
                    };
                    this.$router.push({name:'personbookinfo',query:query})
                  }
                }
              },params.row['fcode'])
            }
          },
          {
            title: ' '
          },
          {
            title: '房间/床位号',
            align: 'center',
            key: 'roomNum',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: '预订单状态',
            align: 'center',
            key: 'reservationStatus',
            width: 160,
            render:(h,params)=>{
              let maps={'1':'已超期','2':'待支付','3':'已支付','4':'已签约','5':'客户违约','6':'公司违约','7':'已取消' }
              return h('span',{},maps[params.row['reservationStatus']+''])
            }
          },
          {
            title: ' '
          },
          {
            title: '预订方式',
            align: 'center',
            key: 'sourceStr',
            width: 160,
            // render:(h,params)=>{
            //   let maps={'1':'已超期','2':'待支付','3':'待签约','4':'已签约','5':'客户违约','6':'公司违约','7':'已取消' }
            //   return h('span',{},maps[params.row['reservationStatus']+''])
            // }
          },
          {
            title: ' ',
          },
          {
            title: '预订人',
            align: 'center',
            key: 'signName',
            width: 100,
          },
          {
            title: ' '
          },
          {
            title: '预订手机号',
            align: 'center',
            key: 'userPhone',
            width: 100,
          },
          {
            title: ' '
          },
          {
            title: '订金',
            align: 'center',
            key: 'depositAccount',
            width: 100,
          },
          {
            title: ' '
          },
          {
            title: '租金',
            align: 'center',
            key: 'houseRentPrice',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: '预订时间',
            align: 'center',
            key: 'createTime',
            width: 120,
            // render: (h, params) => {
            //   return h('span',formatDateTime(params.row.conSignDate,false))
            // }
          },
          {
            title: ' '
          },
          {
            title: '起租日',
            align: 'center',
            key: 'rentStartDate',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: '到期日',
            align: 'center',
            key: 'rentEndDate',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: '客户类型',
            align: 'center',
            key: 'userTypeStr',
            width: 100,
          },
          {
            title: ' '
          },
          {
            title: '租约类型',
            align: 'center',
            key: 'rentTypeStr',
            width: 100,
          },
          {
            title: ' '
          },

          {
            title: '操作',
            align: 'center',
            key: 'action',
            width: 170,
            fixed: 'right',
            render: (h, params) => {
              const { reservationStatus, source } = params.row;
              const cancellation =
                  (source === 3 && reservationStatus === 3)
                  || (source === 1 && [1, 3].includes(reservationStatus));
              return h('div', [
                h('a', {
                  //当状态为待支付时展示
                  style: {
                    marginRight: '5px',
                    display: params.row.reservationStatus === 2 ? 'inline-block' : 'none'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '关闭预订单',
                        content: '<p>继续操作预订单将关闭，此操作不可逆！</p>',
                        onOk: () => {
                          let params1={
                            fid:params.row['fid']
                          }
                          orderclose(params1).then(res=>{
                            this.$Message.success('操作成功')
                            this.getData()

                          }).catch(error=>{
                            this.$Message.info('操作失败')})

                        }
                      })
                    }
                  }
                }, '关闭'),

                h('a', {
                  style: {
                    display: params.row.reservationStatus === 2 && params.row.source !== 3 ?'inline-block' :'none',
                    marginRight: '5px'
                  },
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:['certificate/savePaymentVoucher','certificate/batchSaveCertificate']
                      }
                    }
                  ],
                  on:{
                    click: ()=>{
                      this.isCanCertificate(params)
                    }
                  }
                }, '收款'),

                h('a', {
                  // 当录入状态为已录入时展示
                  style: {
                    marginRight: '5px',
                    display: cancellation ? 'inline-block' :'none'
                  },
                  on: {
                    click: () => {
                      this.reservationOrderFid = params.row.fid
                      this.projectName = params.row.projectName
                      this.projectId = params.row.projectId
                      this.obN++
                    }
                  }
                }, '作废'),

                h('a', {
                  // directives:[
                  //   {
                  //     name:'p',
                  //     value:{
                  //       // menu:'outhouse',
                  //       // api:'checkinPersion/save'
                  //     }
                  //   }
                  // ],
                  // 当录入状态为已录入，且合同类型为企业合同时展示 且合同状态非 已失效 已关闭 已到期 已退租
                  style: {
                    marginRight: '5px',
                    display: (params.row.reservationStatus === 1 || params.row.reservationStatus === 3) && params.row.userType === 1 && params.row.source !== 3 ?'inline-block' :'none'
                  },
                  on: {
                    click: () => {
                      this.reservationOrderFid = params.row.fid
                      this.projectName = params.row.projectName
                      this.projectId = params.row.projectId
                      this.pN++
                    }
                  }
                }, '签约个人'),

                h('a', {
                  // directives:[
                  //   {
                  //     name:'p',
                  //     value:{
                  //       // menu:'outhouse',
                  //       // api:'checkinPersion/save'
                  //     }
                  //   }
                  // ],
                  // 当录入状态为已录入，且合同类型为企业合同时展示 且合同状态非 已失效 已关闭 已到期 已退租
                  style: {
                    marginRight: '5px',
                    display: (params.row.reservationStatus === 1 || params.row.reservationStatus === 3) && params.row.userType === 3 && params.row.source !== 3 ?'inline-block' :'none'
                  },
                  on: {
                    click: () => {
                      this.reservationOrderFid = params.row.fid
                      this.projectName = params.row.projectName
                      this.projectId = params.row.projectId
                      this.bN++
                    }
                  }
                }, '签约企业')])
            }
          }
        ],
        total: 0,
        current: 1,
        loading: false,
        page:1,
        limit:10
      }
    },
    methods: {
      changPage(n){
        this.current = n;
        this.page = n;
        this.getData()

      },
      searchData(data){
        this.searchDataValue = deepClone(data);
        this.current = 1;
        this.page = 1;
        this.getData()

      },
      getData(){
        let params={
          page: this.page,
          limit:this.limit,
          ...this.searchDataValue
        }
        orderlist(params).then(res=>{
          if(!res.data){
            return
          }
          res.data && res.data.rows&&(this.data = res.data.rows);
          this.total = res.data.total

        }).catch(error=>{

        })

      },
      isCanCertificate(params) {
        getBillNum(params.row.fid).then(resp => {
          canCertificate({billNum: resp.data}).then(res => {
            this.billNumber = resp.data
            this.contractCode = params.row.fcode
            this.$router.push({
              name: 'collection',
              query: {
                proId: params.row.projectId,
                bNum: resp.data,
                cCode: params.row.fcode,
                oneTime: 1
              }
            })
          })
        }).catch(error => {

        })

      },

    },
  }
</script>

<style scoped>

</style>
